var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPeopleCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.806274 13.7008V10.7328L7.03027 7.14078L10.0463 8.90078L15.2063 5.90078V13.7008H0.806274ZM15.2063 4.05278L10.0463 7.03678L7.03027 5.30078L0.806274 8.90078V7.13278L7.03027 3.54078L10.0463 5.30078L15.2063 2.30078V4.05278Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeopleCount);
export default __webpack_public_path__ + "static/media/icon-people-count.9fede80b5d0e665846f3935739a2c13d.svg";
export { ForwardRef as ReactComponent };